<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">Settings: Stores</h1>

            <card-box>
                <card-title>Store Defaults</card-title>
                <hr>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-md-right">
                        <strong>Store name:</strong>
                    </label>
                    <div class="col-md-6">
                        <input v-model="item.name" type="text" class="form-control">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-md-right">
                        <strong>Website:</strong>
                    </label>
                    <div class="col-md-6">
                        <input v-model="item.website" type="text" class="form-control">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-md-right">
                        <strong>Consumer Key:</strong>
                    </label>
                    <div class="col-md-6">
                        <input v-model="item.consumer_key" type="text" class="form-control">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-md-right">
                        <strong>Consumer Secret:</strong>
                    </label>
                    <div class="col-md-6">
                        <input v-model="item.consumer_secret" type="text" class="form-control">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-md-right">
                        <strong>Status:</strong>
                    </label>
                    <div class="col-md-6">
                        <div class="form-check">
                            <input id="status_active" type="radio" v-model="item.status" value="1" class="form-check-input"><label for="status_active" class="form-check-label">Active</label>
                        </div>
                        <div class="form-check">
                            <input id="status_intactive" type="radio" v-model="item.status" value="0"  class="form-check-input"><label for="status_intactive" class="form-check-label">Disable</label>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-md-right">
                    </label>
                    <div class="col-md-4">
                        <button @click="saveSetting()" class="btn btn-primary">Save</button>
                    </div>
                </div>

            </card-box>


            <card-box>
                <card-title>Order Import Settings</card-title>
                <hr>
                <div class="form-group row">
                    <div class="form-check offset-4 col-md-6">
                        <input class="form-check-input" type="radio" id="manual" value="0"
                               v-model="item.auto_fulfillment">
                        <label class="form-check-label" for="manual">Manually confirm imported orders</label>
                    </div>
                    <div class="form-check offset-4 col-md-6">
                        <input class="form-check-input" type="radio" id="auto" value="1"
                               v-model="item.auto_fulfillment">
                        <label class="form-check-label" for="auto">Automatically confirm orders to be
                            fulfilled</label>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="form-group offset-4 col-md-6">
                        <button @click="saveSetting()" class="btn btn-primary">Save</button>
                    </div>
                </div>


            </card-box>


        </div>
    </div>
</template>
<script>
    import CardBox from "@/components/CardBox";
    import CardTitle from "@/components/CardTitle";

    export default {
        name: "WooStoreEdit",
        components: {CardTitle, CardBox},
        data: function () {
            return {
                message: "",
                item: {}
            }
        },
        methods: {

            saveSetting: function () {
                let vm = this
                this.$http.put(this.$config.api + 'integrate/store/' + this.id, this.item)
                this.$toasted.show('Saved', {duration: 2000, position: 'bottom-center'})
            },
            loadStore: function () {
                let vm = this
                this.$http.get(this.$config.api + 'integrate/store/' + this.id).then(function (res) {
                    vm.item = res.data
                })
            }

        },
        mounted: function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'integrate_woocommerce')
            this.$store.commit('ACTIVE_SIDEBARSUB', 'integrate_woocommerce')
            this.id = this.$route.params.id
            this.loadStore()

        }
    }
</script>

<style lang="scss" scoped>
    .btn {
        min-width: 100px;
    }

</style>


